import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import ChartAction from '../../../redux/chart/actions'
import Card from '../../../componentsMaterial/Card/Card.jsx'

import withStyles from '@material-ui/core/styles/withStyles'
import {
    DatePicker,
    Icon,
    Tooltip,
    Dropdown,
    Menu,
    Layout,
    Badge,
    Calendar,
    Select,
    Radio,
    Col,
    Row,
    Modal,
} from 'antd'
import moment from 'moment'
import ModalEvent from './modalEvent'
const { Group, Button } = Radio

let date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth()
let firstDay = new Date(y, m - 1, 1)
let lastDay = new Date(y, m + 1, 1)
class EventCalendar extends Component {
    constructor(props) {
        super(props)

        this.state = {
            reload: 0,
            visible: false,
            mode: '',
            date: moment(),
            lstEvent: [],
        }
    }
    componentDidMount() {
        let begintime = moment(firstDay)._d.valueOf() / 1000
        let endtime = moment(lastDay)._d.valueOf() / 1000
        this.props.getDataEvent(begintime, endtime)
    }

    onPanelChange = (value, mode) => {
        console.log(value, mode)
    }
    componentWillReceiveProps(nextprops) {
        // if (
        //     nextprops.dataEvent !== this.props.dataEvent ||
        //     nextprops.dataEventYear !== this.props.dataEventYear
        // ) {
        //     this.setState({ reload: 1 })
        // }
    }
    getListData = data => {
        let listData = []
        this.props.dataEvent.map(value => {
            if (
                data.format('DD/MM/YYYY') ===
                moment(value.begin_time * 1000).format('DD/MM/YYYY')
            ) {
                listData.push(value)
            }
        })
        return listData
    }
    getListDataMonth = data => {
        let listData = []
        this.props.dataEventYear.map(value => {
            if (
                data.format('MM/YYYY') ===
                moment(value.begin_time * 1000).format('MM/YYYY')
            ) {
                listData.push(value)
            }
        })
        return listData
    }
    monthCellRender = value => {
        const listData = this.getListDataMonth(value)
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    fontSize: 10,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    fontFamily:'San Francisco'
                }}
                onClick={() => {
                    this.setState({ visible: true })
                    this.setState({ date: value, mode: 'month' })
                    this.setState({ lstEvent: listData })
                }}
            >
                {listData.map(item => (
                    <li key={item.content}>
                        <Badge style={{color:'white'}} status="success" text={item.name} />
                    </li>
                ))}
            </div>
        )
    }
    getTitleModal = () => {
        let name = 'Sự kiện '
        let mode = this.state.mode === 'day' ? 'ngày' : 'tháng'
        let time =
            this.state.mode === 'day'
                ? this.state.date.format('DD/MM/YYYY')
                : this.state.date.format('MM/YYYY')

        let title = name + mode + ' ' + time

        return (
            <div>
                <Icon
                    type="calendar"
                    style={{ fontSize: 18, paddingRight: 5, paddingBottom: 7 }}
                />{' '}
                {title}
            </div>
        )
    }
    dateCellRender = value => {
        const listData = this.getListData(value)
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    fontSize: 10,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    fontFamily:'San Francisco'
                }}
                onClick={() => {
                    console.log('click')
                    this.setState({ visible: true })
                    this.setState({ date: value, mode: 'day' })
                    this.setState({ lstEvent: listData })
                }}
            >
                {listData.map(item => (
                    <li key={item.content}>
                        <Badge style={{color:'white'}} status="success" text={item.name} />
                    </li>
                ))}
            </div>
        )
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <Card
                    style={{
                        backgroundImage: `url(${require('../../../resource/image/blur-bg.jpg')}`,
                        backgroundSize: 'initial',
                        backgroundPosition: 'center left',
                        height: 900,
                    }}
                >
                    <Calendar
                        style={{ color: 'white' }}
                        onPanelChange={this.onPanelChange}
                        headerRender={({
                            value,
                            type,
                            onChange,
                            onTypeChange,
                        }) => {
                            const start = 0
                            const end = 12
                            const monthOptions = []

                            const current = value.clone()
                            const localeData = value.localeData()
                            const months = []
                            for (let i = 0; i < 12; i++) {
                                current.month(i)
                                months.push(localeData.monthsShort(current))
                            }

                            for (let index = start; index < end; index++) {
                                monthOptions.push(
                                    <Select.Option
                                        className="month-item"
                                        key={`${index}`}
                                    >
                                        {months[index]}
                                    </Select.Option>
                                )
                            }
                            const month = value.month()
                            const year = value.year()
                            const options = []
                            for (let i = year - 10; i < year + 10; i += 1) {
                                options.push(
                                    <Select.Option
                                        key={i}
                                        value={i}
                                        className="year-item"
                                    >
                                        {i}
                                    </Select.Option>
                                )
                            }
                            return (
                                <div
                                    style={{ paddingLeft: 20, paddingTop: 20, fontFamily:'San Francisco'}}
                                >
                                    <div
                                        style={{
                                            marginBottom: '10px',
                                            fontSize: 20,
                                            
                                        }}
                                    >
                                        Lịch sự kiện
                                    </div>
                                    <Row type="flex">
                                        <Col style={{ padding: 10 }}>
                                            <Group
                                                size="small"
                                                onChange={e => {
                                                    onTypeChange(e.target.value)

                                                    if (
                                                        e.target.value ===
                                                        'year'
                                                    ) {
                                                        let date = new Date(),
                                                            y = date.getFullYear(),
                                                            m = date.getMonth()
                                                        let firstDay = new Date(
                                                            y,
                                                            1,
                                                            1
                                                        )
                                                        let lastDay = new Date(
                                                            y + 1,
                                                            m,
                                                            1
                                                        )
                                                        let begintime =
                                                            moment(
                                                                firstDay
                                                            )._d.valueOf() /
                                                            1000
                                                        let endtime =
                                                            moment(
                                                                lastDay
                                                            )._d.valueOf() /
                                                            1000
                                                        this.props.getDataEvent(
                                                            begintime,
                                                            endtime,
                                                            'year'
                                                        )
                                                    }
                                                }}
                                                value={type}
                                            >
                                                <Button value="month">
                                                    Tháng
                                                </Button>
                                                <Button value="year">
                                                    Năm
                                                </Button>
                                            </Group>
                                        </Col>
                                        <Col style={{ padding: 10 }}>
                                            <Select
                                                size="small"
                                                dropdownMatchSelectWidth={false}
                                                style={{minWidth: 80}}
                                                className="my-year-select"
                                                onChange={newYear => {
                                                    const now = value
                                                        .clone()
                                                        .year(newYear)
                                                    let begintime =
                                                        (now
                                                            .startOf('year')
                                                            ._d.valueOf() /
                                                            1000) >>
                                                        0
                                                    let endtime =
                                                        (now
                                                            .endOf('year')
                                                            ._d.valueOf() /
                                                            1000) >>
                                                        0
                                                    this.props.getDataEvent(
                                                        begintime,
                                                        endtime,
                                                        'year'
                                                    )
                                                    onChange(now)
                                                }}
                                                value={String(year)}
                                            >
                                                {options}
                                            </Select>
                                        </Col>
                                        <Col style={{ padding: 10 }}>
                                            <Select
                                                size="small"
                                                dropdownMatchSelectWidth={false}
                                                style={{minWidth: 80}}
                                                value={String(month)}
                                                onChange={selectedMonth => {
                                                    const newValue = value.clone()
                                                    newValue.month(
                                                        parseInt(
                                                            selectedMonth,
                                                            10
                                                        )
                                                    )
                                                    let begintime =
                                                        (newValue
                                                            .subtract(
                                                                1,
                                                                'month'
                                                            )
                                                            .startOf('month')
                                                            ._d.valueOf() /
                                                            1000) >>
                                                        0
                                                    let endtime =
                                                        (newValue
                                                            .add(1, 'month')
                                                            .endOf('month')
                                                            ._d.valueOf() /
                                                            1000) >>
                                                        0

                                                    this.props.getDataEvent(
                                                        begintime,
                                                        endtime
                                                    )

                                                    onChange(newValue)
                                                }}
                                            >
                                                {monthOptions}
                                            </Select>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }}
                        showHeader={false}
                        monthCellRender={value => {
                            return this.monthCellRender(value)
                        }}
                        dateCellRender={value => {
                            return this.dateCellRender(value)
                        }}
                    />
                </Card>
                <Modal
                    visible={this.state.visible}
                    maskClosable={true}
                    title={this.getTitleModal()}
                    onCancel={() => this.setState({ visible: false })}
                    width={650}
                    centered
                    footer={[]}
                >
                    <ModalEvent lstEvent={this.state.lstEvent} />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        dataEvent: state.chartReducer.dataEvent,
        dataEventYear: state.chartReducer.dataEventYear,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDataEvent: (begin_time, end_time, mode) => {
            dispatch(
                ChartAction.action.getListEventDashboard(
                    begin_time,
                    end_time,
                    mode
                )
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventCalendar)
